















import { Component, Vue, Prop, ModelSync } from 'nuxt-property-decorator'
import { mdiCheck } from '@mdi/js'
import { IStyle } from '~/assets/interfaces/classes'
import ComponentIcon from '~/components/icon/icon.vue'

@Component({
  components: {
    ComponentIcon,
  },
})
export default class ComponentFormCheckbox extends Vue {
  @ModelSync('value', 'change', { type: Boolean })
  readonly checkedValue!: boolean

  @Prop({ default: false, type: Boolean }) readonly error!: false
  @Prop({ default: false, type: Boolean }) readonly disabled!: false

  private $style!: IStyle
  private styleAnimation!: IStyle
  private mdiCheck = mdiCheck

  private get classWrapper() {
    return {
      [this.$style.label]: true,
      [this.$style.error]: this.error,
      [this.$style.disabled]: this.disabled,
      [this.styleAnimation.shakeHorizontal]: this.error,
    }
  }

  private get classCheckboxNewInput() {
    return {
      [this.$style.checkboxNewInput]: true,
      [this.$style.active]: this.checkedValue,
    }
  }
}
